/**
 * Constants for AllQueries page component
 */

// Reuse REGION_OPTIONS and STATUS_CARD_CONFIG from raiseQueryPage
export { REGION_OPTIONS, STATUS_CARD_CONFIG } from './raiseQueryPage';

export const LIFECYCLE_STATUS_STYLES = {
  raised: { label: 'Open', color: '#4f9da6' },
  open: { label: 'Open', color: '#4f9da6' },
  pending: { label: 'Pending', color: '#f39c3d' },
  responded: { label: 'Responded', color: '#1e40af' },
  resolved: { label: 'Resolved', color: '#2e7d32' },
  escalated: { label: 'Escalated', color: '#d97706' },
  delegated: { label: 'Delegated', color: '#0ea5e9' },
  reopened: { label: 'Need Clarification', color: '#7c3aed' },
  additional_clarification: { label: 'Additional Clarification', color: '#f59e0b' },
  closed: { label: 'Closed', color: '#388e3c' },
};
